export default "__VITE_ASSET__CQHm5EiT__"